// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Loadings_wrap_3F8ds"};